module.exports = __webpack_public_path__ + "static/media/Group 7-A1.b2e14b68.svg";